import { addJob } from '../State/jobs'

export default () => (dispatch, getState) => {

  const { activeTab } = getState().screens.Planner.SubcontractorCellModal

  dispatch(addJob(activeTab))

}
